export const adaptTipoZona = (tipoZonaData) => {
    return {
        id: tipoZonaData?.idTipoZona,
        displayName: tipoZonaData?.descripcion,
        name: tipoZonaData?.descripcion
    }
}

export const adaptTipoZonaArray = (
    tiposZona
) => {
    return structuredClone(tiposZona?.allTipoZona)
        ?.map(tipoZona => adaptTipoZona(tipoZona));
}